(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"]) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-nf-search]');
    if (!form) return;
    var skip = ['product', 'products', 'product-category', 'product-tag', 'collections', 'collection', 'pages', 'page', 'shop', 'category', 'categories', 'brand', 'brands', 'blogs', 'blog', 'news', 'tag', 'search', 'cart', 'account', 'wp-content', 'uploads', '404'];
    var parts = window.location.pathname.split('/').filter(Boolean);
    var last = parts.length ? parts[parts.length - 1] : '';
    try { last = decodeURIComponent(last); } catch (e) { return; }
    last = last.toLowerCase().replace(/\.(html?|php)$/, '').replace(/[-_+]+/g, ' ').replace(/[^a-z0-9 .\/]/g, ' ').replace(/\s+/g, ' ').trim();
    if (last.length < 3 || skip.indexOf(last) !== -1) return;
    last = last.split(' ').slice(0, 8).join(' ');
    var input = form.querySelector('input[name="q"]');
    if (input && !input.value) input.value = last;
    var guess = document.querySelector('[data-nf-guess]');
    var link = guess && guess.querySelector('a');
    if (!link) return;
    link.textContent = '“' + last + '”';
    link.href = form.getAttribute('action') + '?q=' + encodeURIComponent(last) + '&options%5Bprefix%5D=last';
    guess.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  // Build the table of contents from the headings the article actually has.
  // Anything without at least two H2s gets no rail entry — a one-item contents
  // list is furniture, not navigation.
  class PostToc extends HTMLElement {
    connectedCallback() {
      const body = this.closest('[data-post]')?.querySelector('[data-post-body]');
      if (!body) return;

      const headings = [...body.querySelectorAll('h2')].filter((h) => h.textContent.trim() !== '');
      if (headings.length < 2) return;

      const list = this.querySelector('[data-post-toc-list]');
      if (!list) return;

      const used = new Set();
      const items = headings.map((heading, index) => {
        let id = heading.id;
        if (!id) {
          const base =
            heading.textContent
              .trim()
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-+|-+$/g, '')
              .slice(0, 60) || `section-${index}`;
          id = used.has(base) ? `${base}-${index}` : base;
          heading.id = id;
        }
        used.add(id);

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${id}`;
        link.textContent = heading.textContent.trim();
        link.className = 'post__toc-link';
        item.appendChild(link);
        return { item, link, heading };
      });

      list.append(...items.map((entry) => entry.item));
      this.hidden = false;

      // Highlight the section the reader is in. rootMargin pulls the trigger
      // line up near the top of the viewport so the highlight changes when a
      // heading reaches reading position, not when it first appears.
      if (!('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            items.forEach((candidate) => {
              candidate.link.classList.toggle('is-active', candidate.heading === entry.target);
            });
          });
        },
        { rootMargin: '-15% 0px -70% 0px' }
      );

      items.forEach((entry) => observer.observe(entry.heading));
    }
  }

  if (!customElements.get('post-toc')) {
    customElements.define('post-toc', PostToc);
  }

  // The nav is authored as a plain <nav> so it still renders with no
  // JavaScript; upgrading it here keeps the markup honest.
  document.querySelectorAll('[data-post-toc]').forEach((nav) => {
    if (nav.tagName === 'POST-TOC') return;
    const upgraded = document.createElement('post-toc');
    upgraded.className = nav.className;
    upgraded.hidden = true;
    upgraded.setAttribute('aria-labelledby', nav.getAttribute('aria-labelledby') || '');
    upgraded.innerHTML = nav.innerHTML;
    upgraded.setAttribute('data-post-toc', '');
    nav.replaceWith(upgraded);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-slides"] && !Shopify.designMode) return;
  try {
    
  // The track already scrolls and snaps natively. This adds arrows, dots, the
  // cross-fade layouts and the timer — none of which the banner needs in order
  // to work.
  (() => {
    if (customElements.get('banner-slides')) return;

    class BannerSlides extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;

        this.track = this.querySelector('.slides__track');
        this.slides = [...this.querySelectorAll('.slide')];
        const nav = this.querySelector('[data-slides-nav]');
        if (!this.track || this.slides.length < 2 || !nav) return;

        this.effect = this.dataset.effect || 'slide';
        this.dwell = Math.max(2000, parseInt(this.dataset.interval, 10) || 6000);
        this.calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        // Moving content is exactly what a reduced-motion request is about, so
        // autoplay is refused rather than merely slowed.
        this.auto = this.dataset.autoplay === 'true' && !this.calm;
        this.current = 0;

        // Claim the stacked layouts only now that they can be driven.
        if (this.effect !== 'slide') {
          this.classList.add('slides--enhanced');
          this.slides[0].classList.add('is-active');
        }

        nav.hidden = false;

        const dots = this.querySelector('[data-slide-dots]');
        this.dots = this.slides.map((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'slides__dot';
          dot.innerHTML = '<span class="visually-hidden">' + (i + 1) + '</span>';
          dot.addEventListener('click', () => { this.go(i); this.restart(); }, { signal });
          dots.append(dot);
          return dot;
        });

        this.querySelector('[data-slide-prev]')
          ?.addEventListener('click', () => { this.go(this.index() - 1); this.restart(); }, { signal });
        this.querySelector('[data-slide-next]')
          ?.addEventListener('click', () => { this.go(this.index() + 1); this.restart(); }, { signal });

        if (this.effect === 'slide') {
          this.track.addEventListener('scroll', () => this.mark(), { signal, passive: true });
        } else {
          // Arrow keys work natively on a scrolling track; a stacked banner has
          // to be told, and it has nothing to swipe either.
          this.track.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            this.go(this.index() + (event.key === 'ArrowRight' ? 1 : -1));
            this.restart();
          }, { signal });

          let startX = null;
          this.track.addEventListener('touchstart', (event) => {
            startX = event.changedTouches[0].clientX;
          }, { signal, passive: true });
          this.track.addEventListener('touchend', (event) => {
            if (startX === null) return;
            const dx = event.changedTouches[0].clientX - startX;
            startX = null;
            if (Math.abs(dx) < 45) return;
            this.go(this.index() + (dx < 0 ? 1 : -1));
            this.restart();
          }, { signal, passive: true });
        }

        if (this.auto) {
          this.toggle = this.querySelector('[data-slide-toggle]');
          this.toggleLabel = this.querySelector('[data-slide-toggle-label]');
          this.pauseText = this.toggleLabel?.dataset.pause || '';
          this.playText = this.toggleLabel?.dataset.play || '';

          if (this.toggle) {
            this.toggle.hidden = false;
            this.toggle.addEventListener('click', () => this.setPaused(!this.paused), { signal });
          }

          // Anything that takes the visitor's attention stops the clock: a
          // pointer resting on the banner, a keyboard inside it, a hidden tab,
          // or the banner being scrolled past.
          this.addEventListener('pointerenter', () => this.hold(true), { signal });
          this.addEventListener('pointerleave', () => this.hold(false), { signal });
          this.addEventListener('focusin', () => this.hold(true), { signal });
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.hold(false);
          }, { signal });

          document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
              this.stop();
            } else {
              this.start();
            }
          }, { signal });

          if ('IntersectionObserver' in window) {
            this.io = new IntersectionObserver((entries) => {
              entries.forEach((entry) => (entry.isIntersecting ? this.start() : this.stop()));
            }, { threshold: 0.25 });
            this.io.observe(this);
          } else {
            this.start();
          }
        }

        this.mark();
      }

      disconnectedCallback() {
        this.stop();
        this.io?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }

      index() {
        if (this.effect !== 'slide') return this.current;
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      go(i) {
        const n = this.slides.length;
        const target = ((i % n) + n) % n;

        if (this.effect === 'slide') {
          this.track.scrollTo({
            left: target * this.track.clientWidth,
            behavior: this.calm ? 'auto' : 'smooth',
          });
          return;
        }

        this.slides[this.current]?.classList.remove('is-active');
        this.slides[target].classList.add('is-active');
        this.current = target;
        this.mark();
      }

      mark() {
        const current = this.index();
        this.dots?.forEach((d, i) => d.setAttribute('aria-current', String(i === current)));
      }

      // held = something has the visitor's attention; paused = they asked for it.
      hold(state) {
        this.held = state;
        if (state) {
          this.stop();
        } else {
          this.start();
        }
      }

      setPaused(state) {
        this.paused = state;
        this.toggle?.setAttribute('aria-pressed', String(state));
        if (this.toggleLabel && this.playText) {
          this.toggleLabel.textContent = state ? this.playText : this.pauseText;
        }
        if (state) {
          this.stop();
        } else {
          this.start();
        }
      }

      start() {
        if (!this.auto || this.timer || this.paused || this.held || document.hidden) return;
        this.timer = setInterval(() => this.go(this.index() + 1), this.dwell);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }
    }

    customElements.define('banner-slides', BannerSlides);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const page = document.querySelector('[data-cart-page]');
    if (!page || page.dataset.bound) return;
    page.dataset.bound = 'true';

    const root = () => window.Shopify?.routes?.root || '/';

    async function change(line, quantity) {
      page.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${root()}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity }),
        });
        if (!response.ok) throw new Error('change failed');
        window.location.reload();
      } catch (e) {
        window.location.reload();
      }
    }

    page.addEventListener('click', (event) => {
      const remove = event.target.closest('[data-line-remove]');
      if (remove) {
        event.preventDefault();
        change(Number(remove.dataset.lineRemove), 0);
        return;
      }

      const step = event.target.closest('[data-line-qty]');
      if (step) {
        event.preventDefault();
        const line = Number(step.dataset.lineQty);
        const input = page.querySelector(`[data-line-input="${line}"]`);
        const next = Math.max(0, Number(input?.value || 0) + Number(step.dataset.delta));
        change(line, next);
        return;
      }

      // Shopify applies discount codes at checkout, so the coupon field hands
      // the code to /discount/CODE and comes straight back to the cart.
      const coupon = event.target.closest('[data-coupon-apply]');
      if (coupon) {
        event.preventDefault();
        const code = page.querySelector('[data-coupon-input]')?.value.trim();
        if (code) {
          window.location.href = `${root()}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(`${root()}cart`)}`;
        }
      }
    });

    page.addEventListener('change', (event) => {
      const input = event.target.closest('[data-line-input]');
      if (!input) return;
      change(Number(input.dataset.lineInput), Math.max(0, Number(input.value || 0)));
    });

    // ---------- shipping estimate ----------
    const estimate = page.querySelector('[data-shipping-estimate]');
    if (!estimate) return;

    const country = estimate.querySelector('[data-ship-country]');
    const province = estimate.querySelector('[data-ship-province]');
    const zip = estimate.querySelector('[data-ship-zip]');
    const rates = estimate.querySelector('[data-ship-rates]');

    function fillProvinces() {
      const option = country.selectedOptions[0];
      let list = [];
      try {
        list = JSON.parse(option?.dataset.provinces || '[]');
      } catch (e) {
        list = [];
      }
      province.replaceChildren();
      list.forEach(([value, label]) => {
        const el = document.createElement('option');
        el.value = value;
        el.textContent = label;
        province.append(el);
      });
      province.hidden = list.length === 0;
    }

    country.addEventListener('change', fillProvinces);
    fillProvinces();

    estimate.querySelector('[data-ship-go]')?.addEventListener('click', async () => {
      const params = new URLSearchParams({
        'shipping_address[country]': country.value,
        'shipping_address[province]': province.hidden ? '' : province.value,
        'shipping_address[zip]': zip.value,
      });
      rates.textContent = '…';
      try {
        const data = await fetch(`${root()}cart/shipping_rates.json?${params}`).then((r) => r.json());
        const list = data.shipping_rates || [];
        if (!list.length) {
          rates.textContent = rates.dataset.none || 'No rates found for that address.';
          return;
        }
        rates.replaceChildren((()=>{const esc=s=>String(s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"})[c]);const money=(p,c)=>{const n=parseFloat(p);if(!(n>0))return"FREE";try{return new Intl.NumberFormat("en-US",{style:"currency",currency:c||"USD"}).format(n)}catch(e){return"$"+n.toFixed(2)}};const icons={pickup:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9l1.5-5h15L21 9M3 9h18M3 9v1a3 3 0 006 0 3 3 0 006 0 3 3 0 006 0V9M5 13v7h14v-7M10 20v-4h4v4"/></svg>',local:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7-6.2-7-11.5A7 7 0 0119 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>',ship:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 6h11v10H2zM13 9h4l4 4v3h-8z"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>'};const sorted=list.slice().sort((a,b)=>parseFloat(a.price)-parseFloat(b.price));const wrap=document.createElement("div");wrap.className="shiprates";const zipv=(zip.value||"").trim();wrap.innerHTML='<p class="shiprates__head">Shipping options'+(zipv?' for <strong>'+esc(zipv)+'</strong>':'')+'</p>';const ul=document.createElement("ul");ul.className="shiprates__list";ul.setAttribute("role","list");sorted.forEach(rate=>{let name=String(rate.name||"").replace(/\s*\(R\)\s*$/,"").trim(),sub="",kind="ship";const d=name.match(/\s*\(Expected Delivery By (\d{2})-(\d{2})-(\d{4})\)\s*/i);if(d){name=name.replace(d[0]," ").trim();const dt=new Date(+d[3],+d[1]-1,+d[2]);sub="Est. delivery "+dt.toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"})}if(/pick\s*up/i.test(name)){kind="pickup";const parts=name.split(/\s+[-–]\s+/);name=parts.shift();sub=parts.join(" - ")||sub}else if(/local delivery/i.test(name)){kind="local";sub=sub||"Delivered by Imperial AC Supply"}else if(/freight|ltl/i.test(name)){sub=(sub?sub+" · ":"")+"Truck freight with liftgate"}const free=!(parseFloat(rate.price)>0);const li=document.createElement("li");li.className="shiprates__item shiprates__item--"+kind;li.innerHTML='<span class="shiprates__icon">'+icons[kind]+'</span><span class="shiprates__text"><span class="shiprates__name">'+esc(name)+'</span>'+(sub?'<span class="shiprates__sub">'+esc(sub)+'</span>':'')+'</span><span class="shiprates__price'+(free?' shiprates__price--free':'')+'">'+money(rate.price,rate.currency)+'</span>';ul.appendChild(li)});wrap.appendChild(ul);const note=document.createElement("p");note.className="shiprates__note";note.textContent="Choose your option at checkout. Total below does not include shipping.";wrap.appendChild(note);return wrap})());
      } catch (e) {
        rates.textContent = rates.dataset.none || 'No rates found for that address.';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Progressive enhancement only. Everything above already works without this:
  // the sort control is a real GET form and the filters are a real submit.
  (() => {
    if (document.documentElement.dataset.collectionBound) return;
    document.documentElement.dataset.collectionBound = 'true';

    document.addEventListener('change', (event) => {
      const select = event.target.closest('.collection__sort select');
      if (!select) return;
      const form = select.closest('form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });

    // Grid / list is a display preference, remembered so it survives paging
    // through a category. Only ever holds the strings 'grid' or 'list'.
    const KEY = 'ias:product-view';

    const read = () => {
      try {
        const stored = localStorage.getItem(KEY);
        return stored === 'list' ? 'list' : 'grid';
      } catch (error) {
        return 'grid';
      }
    };

    const apply = (view) => {
      document.querySelectorAll('.product-grid').forEach((grid) => {
        grid.classList.toggle('product-grid--list', view === 'list');
      });
      document.querySelectorAll('.collection__view-button').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.view === view));
      });
    };

    const group = document.querySelector('.collection__view');
    if (group) {
      group.hidden = false;
      apply(read());

      group.addEventListener('click', (event) => {
        const button = event.target.closest('.collection__view-button');
        if (!button) return;
        const view = button.dataset.view === 'list' ? 'list' : 'grid';
        apply(view);
        try {
          localStorage.setItem(KEY, view);
        } catch (error) {
          /* private mode - the choice just does not persist */
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('google-reviews')) return;

    class GoogleReviews extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.track = this.querySelector('[data-track]');
        this.cards = [...this.querySelectorAll('[data-rating]')];
        this.empty = this.querySelector('[data-empty]');
        this.status = this.querySelector('[data-status]');
        this.bar = this.querySelector('[data-filter-bar]');
        this.arrows = this.querySelector('[data-arrows]');
        this.chips = [];
        if (!this.track || !this.cards.length) return;

        if (this.bar) {
          this.chips = [...this.bar.querySelectorAll('[data-value]')];
          this.bar.hidden = false;
          this.bar.addEventListener('click', (event) => {
            const chip = event.target.closest('[data-value]');
            if (chip && !chip.disabled) this.filter(chip.dataset.value);
          });
        }

        if (this.arrows) {
          this.arrows.hidden = false;
          this.arrows.addEventListener('click', (event) => {
            const button = event.target.closest('[data-scroll]');
            if (!button) return;
            // One screenful at a time, so a click never skips a card.
            this.track.scrollBy({ left: this.track.clientWidth * Number(button.dataset.scroll) });
          });
          this.track.addEventListener('scroll', () => this.edges(), { passive: true });
          this.edges();
        }
      }

      filter(value) {
        let visible = 0;
        this.cards.forEach((card) => {
          const match = value === 'all' || card.dataset.rating === value;
          card.hidden = !match;
          if (match) visible += 1;
        });

        // A filter that empties the row has to say so, or it reads as broken.
        if (this.empty) this.empty.hidden = visible > 0;

        this.chips.forEach((chip) => {
          chip.setAttribute('aria-pressed', String(chip.dataset.value === value));
        });

        this.track.scrollTo({ left: 0 });
        if (this.status) {
          this.status.textContent = `${visible} ${visible === 1 ? 'review' : 'reviews'}`;
        }
        this.edges();
      }

      edges() {
        if (!this.arrows) return;
        const max = this.track.scrollWidth - this.track.clientWidth - 1;
        const [prev, next] = this.arrows.querySelectorAll('[data-scroll]');
        prev.disabled = this.track.scrollLeft <= 0;
        next.disabled = this.track.scrollLeft >= max;
      }
    }

    customElements.define('google-reviews', GoogleReviews);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    if (customElements.get('predictive-search')) return;

    class PredictiveSearch extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.input = this.querySelector('[data-psearch-input]');
        this.results = this.querySelector('[data-psearch-results]');
        this.status = this.querySelector('[data-psearch-status]');
        this.form = this.querySelector('form');
        this.index = -1;
        this.timer = null;
        this.controller = null;

        this.input.addEventListener('input', () => this.onType());
        this.input.addEventListener('focus', () => this.onType());
        this.addEventListener('keydown', (event) => this.onKey(event));
        this.form.addEventListener('submit', () => this.close());

        // Anything outside the component dismisses it, including a tap on the
        // page behind on touch devices.
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.close();
        });
      }

      onType() {
        const term = this.input.value.trim();
        clearTimeout(this.timer);

        if (term.length < 2) {
          this.close();
          return;
        }

        // Typing is fast and the endpoint is not; wait for a pause, and drop
        // any request that is already in flight so results can't arrive out of
        // order and overwrite newer ones.
        this.timer = setTimeout(() => this.fetch(term), 200);
      }

      async fetch(term) {
        this.controller?.abort();
        this.controller = new AbortController();

        const root = window.Shopify?.routes?.root || '/';
        const params = new URLSearchParams({
          q: term,
          section_id: 'predictive-search',
          'resources[type]': 'product',
          'resources[limit]': '8',
          // Contractors search model numbers, so variant SKUs have to be part
          // of the match, not just titles and vendors.
          'resources[options][fields]': 'title,product_type,variants.title,variants.sku,vendor,tag',
          'resources[options][unavailable_products]': 'last',
        });

        try {
          const html = await fetch(`${root}search/suggest?${params}`, {
            signal: this.controller.signal,
          }).then((r) => r.text());

          const panel = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('[data-psearch-panel]');
          if (!panel) return;

          this.results.replaceChildren(panel);
          this.open();
        } catch (e) {
          if (e.name !== 'AbortError') this.close();
        }
      }

      get options() {
        return [...this.results.querySelectorAll('[role="option"]')];
      }

      open() {
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        this.index = -1;
        this.mark();
        if (this.status) {
          this.status.textContent = `${this.options.length} ${this.status.dataset.noun || ''}`.trim();
        }
      }

      close() {
        this.results.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        this.index = -1;
      }

      mark() {
        const options = this.options;
        options.forEach((el, i) => el.classList.toggle('is-active', i === this.index));
        const current = options[this.index];
        if (current) {
          this.input.setAttribute('aria-activedescendant', current.id);
          current.scrollIntoView({ block: 'nearest' });
        } else {
          this.input.removeAttribute('aria-activedescendant');
        }
      }

      onKey(event) {
        if (event.key === 'Escape') {
          this.close();
          return;
        }

        if (this.results.hidden) return;
        const options = this.options;
        if (!options.length) return;

        // The cycle runs -1 (the field itself) through the last row and back,
        // so arrowing past the end returns focus to what was typed rather than
        // trapping the user in the list.
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const last = options.length - 1;
          if (event.key === 'ArrowDown') {
            this.index = this.index >= last ? -1 : this.index + 1;
          } else {
            this.index = this.index <= -1 ? last : this.index - 1;
          }
          this.mark();
          return;
        }

        // Enter on a highlighted row opens that product. Enter with nothing
        // highlighted submits the form and lands on the full results page.
        if (event.key === 'Enter' && this.index > -1) {
          event.preventDefault();
          options[this.index].click();
        }
      }
    }

    customElements.define('predictive-search', PredictiveSearch);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-wall"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('brand-wall')) return;

    class BrandWall extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.track = this.querySelector('[data-wall-track]');
        const section = this.closest('.logowall');
        this.nav = section?.querySelector('[data-wall-nav]');
        if (!this.track || !this.nav) return;

        this.prev = this.nav.querySelector('[data-wall-prev]');
        this.next = this.nav.querySelector('[data-wall-next]');

        this.prev?.addEventListener('click', () => this.page(-1));
        this.next?.addEventListener('click', () => this.page(1));
        this.track.addEventListener('scroll', () => this.mark(), { passive: true });

        if (window.ResizeObserver) {
          new ResizeObserver(() => this.mark()).observe(this.track);
        } else {
          window.addEventListener('resize', () => this.mark());
        }

        this.mark();
      }

      page(direction) {
        this.track.scrollBy({ left: this.track.clientWidth * direction });
      }

      // Arrows only exist when there is something off-screen, and each one
      // switches off at its own end of the row. With the slide limit in place
      // a small register can now fit on one screen, in which case the whole
      // control disappears rather than sitting there disabled.
      mark() {
        const overflow = this.track.scrollWidth - this.track.clientWidth;
        this.nav.hidden = overflow < 4;
        if (this.nav.hidden) return;
        const left = this.track.scrollLeft;
        if (this.prev) this.prev.disabled = left < 4;
        if (this.next) this.next.disabled = left > overflow - 4;
      }
    }

    customElements.define('brand-wall', BrandWall);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-nav"]) return;
  try {
    
  // Two jobs. On wide screens: close one <details> when another opens, close on
  // Escape, close when focus leaves. On small screens: hand the same menus to a
  // <dialog> drawer. Everything here is an enhancement — remove this file and
  // the navigation still opens, it just opens in place.
  (() => {
    if (customElements.get('nav-menu')) return;

    class NavMenu extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;

        this.addEventListener('keydown', this.onKeydown, { signal });
        this.addEventListener('focusout', this.onFocusOut, { signal });
        this.addEventListener('toggle', this.onToggle, { capture: true, signal });

        this.dialog = this.querySelector('dialog.drawer');
        this.opener = this.querySelector('[data-drawer-open]');

        // Only claim the small-screen navigation once we know the drawer is
        // actually usable in this browser.
        if (this.dialog && this.opener && typeof this.dialog.showModal === 'function') {
          this.closest('.mainnav')?.classList.add('mainnav--enhanced');

          this.opener.addEventListener('click', () => this.dialog.showModal(), { signal });

          this.dialog.querySelector('[data-drawer-close]')
            ?.addEventListener('click', () => this.dialog.close(), { signal });

          // Clicking the dark area outside the panel closes it. The panel fills
          // the dialog, so any click landing on the dialog itself is a backdrop
          // click.
          this.dialog.addEventListener(
            'click',
            (event) => {
              if (event.target === this.dialog) this.dialog.close();
            },
            { signal }
          );

          // Following a link inside the drawer should not leave it open behind
          // the new page in browsers that restore the dialog from bfcache.
          this.dialog.addEventListener(
            'click',
            (event) => {
              if (event.target.closest('a[href]')) this.dialog.close();
            },
            { signal }
          );

          this.dialog.addEventListener('close', () => this.opener.focus(), { signal });
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }

      closeAll(except, returnFocus) {
        this.querySelectorAll('.mainnav__inner details[open], details.mainnav__browse[open]').forEach((d) => {
          if (d === except || d.closest('.drawer')) return;
          d.open = false;
          if (returnFocus) d.querySelector('summary')?.focus();
        });
      }

      onToggle = (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.open) return;
        // Inside the drawer several groups may sit open at once; only the bar
        // behaves like a menubar.
        if (details.closest('.drawer')) return;
        this.closeAll(details, false);
      };

      onKeydown = (event) => {
        if (event.key === 'Escape') this.closeAll(null, true);
      };

      onFocusOut = (event) => {
        if (this.dialog?.open) return;
        if (!this.contains(event.relatedTarget)) this.closeAll(null, false);
      };
    }

    customElements.define('nav-menu', NavMenu);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
  // Fetches itself back from the recommendations endpoint, then runs the row.
  (() => {
    if (customElements.get('product-related')) return;

    class ProductRelated extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        // Already filled: this instance came from the fetch below.
        if (this.querySelector('[data-prel-track]')) return this.setup();

        const url = this.dataset.url;
        if (!url) return;

        fetch(url)
          .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
          .then((text) => {
            const fetched = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('product-related');
            if (!fetched || !fetched.querySelector('[data-prel-track]')) return;
            this.innerHTML = fetched.innerHTML;
            this.setup();
          })
          .catch(() => {
            // A row of suggestions is not worth reporting a failure over.
          });
      }

      setup() {
        this.track = this.querySelector('[data-prel-track]');
        this.nav = this.querySelector('[data-prel-nav]');
        if (!this.track || !this.nav) return;

        this.prev = this.querySelector('[data-prel-prev]');
        this.next = this.querySelector('[data-prel-next]');

        this.prev?.addEventListener('click', () => this.page(-1));
        this.next?.addEventListener('click', () => this.page(1));
        this.track.addEventListener('scroll', () => this.mark(), { passive: true });

        if (window.ResizeObserver) {
          new ResizeObserver(() => this.mark()).observe(this.track);
        } else {
          window.addEventListener('resize', () => this.mark());
        }

        this.mark();
      }

      page(direction) {
        this.track.scrollBy({ left: this.track.clientWidth * direction });
      }

      // Arrows only exist when there is something off-screen, and each one
      // switches off at its own end of the row.
      mark() {
        const overflow = this.track.scrollWidth - this.track.clientWidth;
        this.nav.hidden = overflow < 4;
        if (this.nav.hidden) return;
        const left = this.track.scrollLeft;
        if (this.prev) this.prev.disabled = left < 4;
        if (this.next) this.next.disabled = left > overflow - 4;
      }
    }

    customElements.define('product-related', ProductRelated);
  })();

  } catch(e) { console.error(e); }
})();
})();
